import React, { FC } from 'react';
import classnames from 'classnames';
import { Icon, Text } from '@cubeyou-team/hx-react-components';

const VARIANT_MAP = {
  dark: 'dark',
  white: 'white',
} as const;

interface ToolbarQueryBadgeProps {
  icon: string;
  label: string;
  className: string;
  variant: typeof VARIANT_MAP[keyof typeof VARIANT_MAP];
}

export const ToolbarQueryBadge: FC<ToolbarQueryBadgeProps> = ({
  icon,
  label,
  className,
  variant,
}) => {
  return (
    <div
      className={classnames(
        'flex items-center justify-between gap-4 h-14 rounded px-6',
        className
      )}
    >
      <Icon icon={icon} size="medium" variant={variant} />
      <Text size="xbody" weight="bold" variant={variant}>
        {label}
      </Text>
    </div>
  );
};
